import { useEffect, useRef, useState } from 'react';
import { fetchAccountAvatarObjectUrl } from '../services/account-avatar.service';

/**
 * Loads the authenticated user's account avatar as an object URL (the bytes are
 * served raw + authenticated, so they can't be a plain `<img src>`). Returns
 * null when none exists. The object URL is revoked on unmount.
 *
 * `bump` lets a caller force a reload after upload/remove.
 */
export function useAccountAvatar(bump = 0): { avatarUrl: string | null } {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const current = useRef<string | null>(null);

  useEffect(() => {
    let active = true;
    void fetchAccountAvatarObjectUrl().then((url) => {
      if (!active) {
        if (url) URL.revokeObjectURL(url);
        return;
      }
      if (current.current && current.current !== url) {
        URL.revokeObjectURL(current.current);
      }
      current.current = url;
      setAvatarUrl(url);
    });
    return () => {
      active = false;
    };
  }, [bump]);

  useEffect(
    () => () => {
      if (current.current) URL.revokeObjectURL(current.current);
    },
    [],
  );

  return { avatarUrl };
}
